import { isEmpty, isObject, isString } from 'lodash-es';

export function valueExtractorHelper(value: any): string {
    return isString(value)
        ? value
        : isObject(value)
            ? isEmpty(value) ? '' : (value as any).value
            : '';
}
